import { useMutation, useQueryClient } from "@tanstack/react-query"
import { addCompanyAddress, type CompanyAddressPayload } from "@/lib/api/company.api"
import { useAuthStore } from "@/store/auth.store"

export function useAddCompanyAddress(companyId: string | null | undefined) {
  const token = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: CompanyAddressPayload) => {
      if (!token) throw new Error("No token available")
      if (!companyId) throw new Error("No company ID available")
      return addCompanyAddress(companyId, payload, token)
    },
    onSuccess: () => {
      if (companyId) {
        queryClient.invalidateQueries({ queryKey: ["company", companyId] })
        queryClient.invalidateQueries({ queryKey: ["company-addresses", companyId] })
      }
    },
  })
}
